<script lang="ts">
  // Der Lage-Satz (docs/gestaltung.md, Regel 3) als EIN Baustein: Teile mit
  // Ton, die Ausnahme vorn -- „sdf auf Forge auffällig · ✓ 13 ok". Bis
  // 03.10.2026 zeichneten ihn Sektionskopf, Aufgaben und Topologie je
  // selbst nach.
  //
  // „ok": der Haken ist immer grün, der Text erst mit der Einstellung
  // „Zustand zeigen: alles" (.lage-ok in app.css). Trenner als Ausdruck:
  // Svelte 5 schneidet Leerraum am Rand eines Elements ab. `titel` setzt
  // einen Tooltip an den Teil (seit 21.10.2026, Zählung der Zugriffe).
  import type { LageTeil } from "./lage";

  let { teile }: { teile: LageTeil[] } = $props();
</script>

{#each teile as teil, i (i)}{#if i > 0}<span class="text-fg-subtle">{" · "}</span>{/if}{#if teil.ton === "ok"}<span class="text-success" aria-hidden="true">{"✓ "}</span><span class="lage-ok" title={teil.titel}>{teil.text}</span>{:else if teil.ton === "danger"}<span class="text-danger font-medium" title={teil.titel}>{teil.text}</span>{:else if teil.ton === "warn"}<span class="text-warning font-medium" title={teil.titel}>{teil.text}</span>{:else if teil.ton === "accent"}<span class="text-laeuft font-medium" title={teil.titel}>{teil.text}</span>{:else if teil.titel}<span title={teil.titel}>{teil.text}</span>{:else}{teil.text}{/if}{/each}
